import { requireConfig, saveConfig } from '../lib/config'
import { FlightDeskAPI } from '../lib/api'

export async function syncCommand(): Promise<void> {
  const config = requireConfig()

  if (config.organizations.length === 0) {
    console.error('No organizations configured. Run: flightdesk init')
    process.exit(1)
  }

  console.log('🔄 Syncing repository mappings...\n')

  let totalProjects = 0
  const newMappings: Record<string, string> = {}

  for (const org of config.organizations) {
    console.log(`  ${org.name}...`)

    try {
      const api = FlightDeskAPI.fromConfig(config, org)
      const projects = await api.listProjects()

      console.log(`    Found ${projects.length} project(s)`)

      for (const project of projects) {
        if (project.githubRepo) {
          newMappings[project.githubRepo] = org.id
          totalProjects++
        }
      }
    } catch (error) {
      console.log(`    ❌ Error: ${error}`)
    }
  }

  // Update config with new mappings
  config.repoMapping = newMappings
  saveConfig(config)

  console.log('')
  console.log(`✅ Synced ${totalProjects} project(s)`)

  if (totalProjects > 0) {
    console.log('')
    console.log('Repository mappings:')
    for (const [repo, orgId] of Object.entries(newMappings)) {
      const org = config.organizations.find(o => o.id === orgId)
      console.log(`  ${repo} → ${org?.name || orgId}`)
    }
  }
}
